export const getOrder = (item: 'inicio' | 'categorias' | 'servicos_destaque' | 'indicadores' | 'banners' | 'canais_atendimento' | 'noticias' | 'app_governo'): number => {
  const order: Array<any> = (window as any)._env_.REACT_APP_ORDER_HOME_PAGE.split(',') ?? [];

  return order.findIndex((findOrder) => findOrder === item);
};

export default { getOrder };
